import React from 'react';
import {ErrorReportBoundary} from '@homeaway/react-error-reporter';
import PropTypes from 'prop-types';

import './ErrorBoundary.less';

const ErrorPanel = ({errorMessage}) => {
    return (
        <div className="ErrorPanel__Container">
            <div className="ErrorPanel__Message">{errorMessage}</div>
        </div>
    );
};

const handleError = (error, errorInfo) => {
    if (process.env.NODE_ENV !== 'development' && window.Sentry) {
        window.Sentry.captureException(error, {extra: errorInfo});
    }
};

export const withErrorBoundary = (
    children,
    errorMetricName = 'generic_ui_error',
    fallbackUI
) => {
    const errorBoundaryProps = {
        ...((fallbackUI && {
            fallbackUI,
        }) ||
            (process.env.NODE_ENV !== 'production' && {
                fallbackUI: <ErrorPanel errorMessage={errorMetricName} />,
            })),
        name: errorMetricName,
        onError: handleError,
    };

    return (
        <ErrorReportBoundary {...errorBoundaryProps}>
            {children}
        </ErrorReportBoundary>
    );
};

withErrorBoundary.propTypes = {
    children: PropTypes.element.isRequired,
    errorMetricName: PropTypes.string,
    fallbackUI: PropTypes.element,
};
